<template>
  <div>
    <div style="background-color: #fff;height: 470px;" class="flex flex-col justify-center items-center">
      <div class="flex flex-col items-center">
        <el-upload
          :file-list="fileList"
          class="upload-demo w-[400px]"
          :headers="{ Authorization:`Bearer ${getToken()}` }"
          :action="UploadFileUrls.normal"
          :on-error="() => { loading = false }"
          :before-upload="onBeforeUpload"
          :on-success="(res: any) => { resolveUploaded(res) }"
          :on-remove="(file: any) => { removeUploaded(file) }"
          :limit="1"
          accept="xls,xlsx"
          drag
        >
          <svg-icon icon="material-symbols:backup-rounded" style="width: 100px ;height: 100px ;color: #909399;" />
          <div class="el-upload__text">
            将文件拖拽到这里或 <em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip text-center">
              仅支持Excel格式，<span style="color: #409EFF; cursor: pointer;" @click="downloadTemplate">模板下载</span>
            </div>
          </template>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { SvgIcon } from '@vue3/components';
import { EAxiosResponseCode, getToken } from '@core/api';
import { PropType, ref } from 'vue';
import { importDutyFreelancer, queryFreelancerGroup, UploadFileUrls } from '@core/main';
import { ElMessage, UploadProps } from 'element-plus';
import { IFreelancerImportItem, IImportFreelancer } from '@core/main/types';
import { useRoute } from 'vue-router';

const props = defineProps({
  uploadFormData: {
    type: Object as PropType<IImportFreelancer>,
    default() {
      return {};
    },
  },
});

const route = useRoute();

const fileList = ref<any[]>([]);
const loading = ref(false);
const templateUrl = ref('');
const form = ref<any>({ items: [] });

const tableData = ref<IFreelancerImportItem[]>([]);
const groupOptions = ref([]);
const onBeforeUpload: UploadProps['beforeUpload'] = (file) => {
  loading.value = false;
  const fileExt = file.name.split('.').pop()
    .toLocaleLowerCase();

  const fileType = ['xls', 'xlsx'];

  if (!fileType.includes(fileExt)) {
    ElMessage.error('只能上传xls,xlsx格式文件');
    return false;
  } else if (file.size / 1024 / 1024 > 5) {
    ElMessage.error('文件大小不能超过5MB');
    return false;
  }
  loading.value = true;
  return true;
};

const resolveUploaded = async (res: any) => {
  const { code, context, message } = res || {};

  loading.value = false;

  if (String(code) === EAxiosResponseCode.Succeed) {
    fileList.value = [
      {
        name: context.fileName,
        url: context.fileUrl,
        fileName: context.fileName,
        fileUrl: context.fileUrl,
      },
    ];
    templateUrl.value = context.fileUrl;
    await readTemp(context.fileUrl);
  } else {
    ElMessage.error(message);
  }
};

const readTemp = async (url: string) => {
  try {
    const res = await importDutyFreelancer({
      dutyId: Number(route.query.dutyId),
      fileUrl: url,
    });

    tableData.value = res?.items;
    form.value.items = res?.items;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
};

const removeUploaded = (file: any) => {
  fileList.value = [];
  templateUrl.value = '';
  tableData.value = [];
  form.value.items = [];
};

// 下载模板
function downloadTemplate() { 
  window.open('https://lg-test-1314932667.cos.ap-nanjing.myqcloud.com/file/2/dca0c6c7f9dc42cbb2242c62fb95ca96/自由职业者导入模版.xlsx');
}

async function getGroupOption() {
  try {
    groupOptions.value = await queryFreelancerGroup();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function init() {
  getGroupOption();
  form.value = props.uploadFormData;
}

init();

async function validate(callback?: () => void) {
  let valid = false;

  if (!form.value?.items || form.value?.items?.length < 1) {
    ElMessage.error('请上传人员信息');
    return valid;
  }

  valid = true;
  callback && callback();

  return valid;
}

defineExpose({
  /**
   * 信息校验
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 获取表单数据 */
  getValues: () => form.value,
  /** 表单数据重置（base props.data） */
});
</script>
